import { render, staticRenderFns } from "./medsos_mention_reach.vue?vue&type=template&id=8bf40c5c&scoped=true"
import script from "./medsos_mention_reach.vue?vue&type=script&lang=js"
export * from "./medsos_mention_reach.vue?vue&type=script&lang=js"
import style0 from "./medsos_mention_reach.vue?vue&type=style&index=0&id=8bf40c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf40c5c",
  null
  
)

export default component.exports